import setAnalyticsDataLayer from './setAnalyticsData';
import { storageSet } from './libs/localStorage';

const sendToBasket = async (params) => {
  const formData = new FormData();
  formData.append('ajax_basket', `${params.ajax_basket}`);
  formData.append('quantity', `${params.quantity}`); // todo брать кол-во товара из инпута
  formData.append('id', `${params.id}`);
  formData.append('prop[0]', '0');

  const data = new URLSearchParams(formData);

  try {
    const rawResponse = await fetch('/local/ajax/basket/sendToBasket.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: data,
    });

    const responseToString = await rawResponse.text();
    const response = JSON.parse(responseToString);

    return response;
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);

    return null;
  }
};

const refreshQuantityValue = (fieldInput) => {
  const parentElem = fieldInput.closest('.product-card__buttons');
  if (parentElem) {
    let buyButton = parentElem.querySelector('.product-card__buttons-buy');
    if (!buyButton) buyButton = document.querySelector('.description-product__add[data-ecommerce-id]');

    if (buyButton) {
      buyButton.attributes['data-ecommerce-quantity'].value = +fieldInput.value;
    }
  }
};

const initBuyButtons = (btns, withUniqueCheck = false) => {
  btns.forEach((button) => {
    if (button.classList.contains('init') && !withUniqueCheck) return;

    button.addEventListener('click', async (e) => {
      e.preventDefault();

      let elem = null;
      if (e.target.classList.contains('.product-card__buttons-buy')) elem = e.target;
      else elem = e.target.closest('.product-card__buttons-buy');

      if (!elem) {
        if (e.target.classList.contains('.description-product__add')) elem = e.target;
        else elem = e.target.closest('.description-product__add');
      }

      if (elem) {
        const { attributes } = elem;

        const fetchParams = {
          ajax_basket: 'Y',
          id: attributes['data-ecommerce-id'].value || '',
          quantity: attributes['data-ecommerce-quantity'].value || 1,
        };

        const result = await sendToBasket(fetchParams);

        if (!result || result.STATUS !== 'OK') {
          return;
        }

        const ecommerceAction = attributes['data-goal'].value || '';
        const ecommerceParams = {
          name: attributes['data-ecommerce-name'].value || '',
          id: attributes['data-ecommerce-id'].value || '',
          price: attributes['data-ecommerce-price'].value || 0,
          quantity: attributes['data-ecommerce-quantity'].value || 1,
        };

        setAnalyticsDataLayer(ecommerceAction, ecommerceParams);

        let basketItems = window.localStorage.getItem('basketItems');
        if (!basketItems) basketItems = [];

        storageSet({ key: 'basketItems', value: result.basketItems });
        window.basketUpdate();
      }
    });

    button.classList.add('init');
  });
};

const initCounterButtons = (btns, withUniqueCheck = false) => {
  btns.forEach((block) => {
    if (block.classList.contains('init') && !withUniqueCheck) return;

    let isItemDetailPage = false;
    const detailPageTitle = document.querySelector('.head-product__title');
    if (detailPageTitle)isItemDetailPage = true;

    const lessButton = block.querySelector('.calc-product__less');
    const moreButton = block.querySelector('.calc-product__more');
    const fieldInput = block.querySelector('.calc-product__field input');

    const { attributes } = fieldInput;
    const minStep = attributes['data-min'].value;

    moreButton.addEventListener('click', (evt) => {
      if (isItemDetailPage) {
        const moreButtons = document.querySelectorAll('.calc-product__more-inner');
        moreButtons.forEach((el) => {
          if (el !== moreButton && evt.isTrusted) {
            const click = new Event('click');
            el.dispatchEvent(click);
          }
        });
      }
      fieldInput.value = +fieldInput.value + +minStep;
      refreshQuantityValue(fieldInput);
    });

    lessButton.addEventListener('click', (evt) => {
      if (+fieldInput.value <= minStep) return;
      if (isItemDetailPage) {
        const lessButtons = document.querySelectorAll('.calc-product__less-inner');
        lessButtons.forEach((el) => {
          if (el !== lessButton && evt.isTrusted) {
            const click = new Event('click');
            el.dispatchEvent(click);
          }
        });
      }

      fieldInput.value = +fieldInput.value - +minStep;
      refreshQuantityValue(fieldInput);
    });

    fieldInput.addEventListener('change', () => {
      if (+fieldInput.value === 0) {
        fieldInput.value = +minStep;

        return;
      }

      if (+fieldInput.value % +minStep !== 0) {
        const itemCount = Math.trunc(+fieldInput.value / +minStep);

        if (itemCount === 0) {
          fieldInput.value = +minStep;

          return;
        }

        fieldInput.value = +minStep * itemCount;

        refreshQuantityValue(fieldInput);
      }
    });

    block.classList.add('init');
  });
};

const initBuyScript = (withUniqueCheck = false) => {
  const buyButtons = document.querySelectorAll('[data-goal="add_cart"]');
  const countersBlocks = document.querySelectorAll('.product-card__buttons-calc');

  initBuyButtons(buyButtons, withUniqueCheck);
  initCounterButtons(countersBlocks, withUniqueCheck);
};

initBuyScript();

window.initBuyScript = initBuyScript;
